import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import FileCopyIcon from '@material-ui/icons/FileCopyRounded';
import ListItem from '@material-ui/core/ListItem';
import ACButton from '../../atoms/ACButton';
import Tooltip from '@material-ui/core/Tooltip';

import { getChallengeTypes } from '../../common/challenges';

import { getIndicatorColor } from '../../common/global';
import styles from './Challenge.module.scss';

export default class Challenge extends React.Component {
  onClickClone = (e) => {
    const { challenge = {}, onCopyChallengeFunc } = this.props;
    onCopyChallengeFunc(cloneDeep(challenge));
    e.stopPropagation();
  };

  onClickChallenge = () => {
    const { challenge = {}, onClickChallengeFunc } = this.props;
    onClickChallengeFunc(challenge);
  };

  renderChallengeType() {
    let { challenge = { type: '' } } = this.props;
    let challengeTypeName = '';

    const findChallengeType = getChallengeTypes().find((cType) => {
      return cType.value === challenge.type;
    });

    if (!isEmpty(findChallengeType)) {
      challengeTypeName = findChallengeType.name;
    }

    if (!isEmpty(challengeTypeName)) {
      return (
        <Tooltip title={challengeTypeName}>
          <div className={styles.challengeType}>
            <ACButton
              text={challengeTypeName}
              backgroundColor={'#616161'}
              spanMargin="0 0"
              color={'white'}
            />
          </div>
        </Tooltip>
      );
    } else return null;
  }

  render() {
    const { challenge = {} } = this.props;
    const { subChallenges = [], status = '' } = challenge;
    let rootStyle = [styles.root];

    if (!isEmpty(subChallenges)) rootStyle.push(styles.hasSubChallenges);

    let borderLeftStyle = `3px solid ${getIndicatorColor(status)}`;

    return (
      <ListItem
        className={rootStyle.join(' ')}
        style={{ marginLeft: '5px', borderLeft: borderLeftStyle }}
        onClick={this.onClickChallenge}
      >
        <div className={styles.challenge}>
          <div className={styles.challengeDetails}>
            <span className={styles.boldFont}>{challenge.name}</span>
          </div>
          {this.renderChallengeType()}
          <div>
            <ACButton text="Clone" onClickFunc={this.onClickClone} icon={<FileCopyIcon />} />
          </div>
        </div>
      </ListItem>
    );
  }
}
